export const practitionerSuppliersFields = [
  {
    name: 'implantSupplier',
    label: "Fournisseurs d'implants",
    type: 'supplier',
    price: true,
    priceLabel: 'Tarif de l’implant proposé (fourchette de prix) : ',
    priceFieldName: 'implantPrice',
    priceFields: ['min', 'max'],
    priceEndAdornment: '€'
  },
  {
    name: 'orthoLabSupplier',
    label: 'Fournisseurs de labos d’orthodontie',
    type: 'supplier',
    price: true,
    priceFieldName: 'orthoPrice',
    priceLabel: 'Tarif du semestre ortho (hors aligneurs) :',
    priceFields: ['child', 'adult'],
    priceEndAdornment: '€'
  },
  {
    name: 'alignerSupplier',
    label: "Fournisseurs d'aligneurs",
    type: 'supplier',
    price: true,
    priceFieldName: 'alignerPrice',
    priceLabel: 'Tarif du semestre ortho par aligneur adulte :',
    priceFields: ['adult'],
    priceEndAdornment: '€'
  },
  {
    name: 'prosthesisSupplier',
    label: 'Fournisseurs de prothèses',
    type: 'supplier',
    price: true,
    priceFieldName: 'ceramicCrownPrice',
    priceLabel: 'Tarif de la couronne céramo-céramique (fourchette de prix) :',
    priceFields: ['min', 'max'],
    priceEndAdornment: '€'
  }
];
